import { Controller } from "@hotwired/stimulus";
import { initializeAccordion } from "../../../shared";

export default class extends Controller {
  connect() {
    initializeAccordion(this.element)
  }

  submitRequest(event) {
    loader.show();
    const form = event.target.closest("form");
    form.requestSubmit();
  }
}
